export function dedicatedContracts(
  state = {
    results: [],
    loading: false,
  },
  action
) {
  switch (action.type) {
    case 'CREATE_DEDICATED_CONTRACT_DONE':
      return {
        ...state,
        results: state.results.concat(action.dedicatedContract),
      };
    case 'UPDATE_DEDICATED_CONTRACT_DONE':
      return {
        ...state,
        results: state.results
          .filter((contract) => contract.id !== action.dedicatedContract.id)
          .concat(action.dedicatedContract),
      };
    case 'SET_CONTRACT_LOADING':
      return {
        ...state,
        results: state.results.map((contract) =>
          contract.id === action.payload.id
            ? {
                ...contract,
                loading: action.payload.loading,
              }
            : contract
        ),
      };
    case 'LOAD_DEDICATED_CONTRACTS_DONE':
      return {
        ...state,
        results: action.dedicatedContracts,
        loading: false,
      };
    case 'LOAD_DEDICATED_CONTRACTS_REQUEST':
      return {
        ...state,
        results: [],
        loading: true,
      };
    default:
      return state;
  }
}
